import type { LibraryItem as SDKLibraryItem } from '@speechifyinc/multiplatform-sdk';

import { MultiplatformSDKInstance } from '../../sdk';
import { SDKFacade } from '../_base';
import { ItemListenableContent } from './item';
import { ListenableContent } from './types';

export class SDKContentFacade extends SDKFacade {
  private static _singleton: SDKContentFacade;

  constructor(sdk: MultiplatformSDKInstance) {
    super(sdk);
    SDKContentFacade._singleton = this;
  }

  static override get singleton(): SDKContentFacade {
    return SDKContentFacade._singleton;
  }

  private isContent = (item: SDKLibraryItem): item is SDKLibraryItem.Content => {
    const { LibraryItem } = this.sdk.sdkModule;
    return item instanceof LibraryItem.Content || item instanceof LibraryItem.DeviceLocalContent;
  };

  public createListenableContent = (item: SDKLibraryItem): ListenableContent => {
    if (this.isContent(item)) {
      return new ItemListenableContent(this.sdk, item as SDKLibraryItem.Content);
    }

    throw new Error('createListenableContent error: Invalid item type');
  };
}
